import { get as _get } from "lodash";
import { defaultProvider } from "../helpers/contracts";
import { awaitTimeout } from "./timers";

const POLL_INTERVAL = 1500;
const WAIT_TIMEOUT = 90 * 1000;

export const TX_TIMEOUT = "TX_TIMEOUT";
export const TX_REVERTED = "TX_REVERTED";

/**
 * Whether the transaction reverted, from the receipt of the block that includes it
 * Reverted transactions are included (they pay mana) with reverted: true; null when the receipt can not be read
 */
export const isTransactionReverted = async (transactionId, blockId) => {
  try {
    const response = await defaultProvider.call("block_store.get_blocks_by_id", {
      block_ids: [blockId],
      return_block: false,
      return_receipt: true,
    });
    const receipts = _get(response, "block_items[0].receipt.transaction_receipts", []);
    const receipt = receipts.find((item) => item.id === transactionId);
    return receipt ? receipt.reverted === true : null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

/**
 * Waits until the transaction is included in a block
 * Throws TX_TIMEOUT when it is not found before the timeout, TX_REVERTED when the contract reverted it
 */
export const waitTransation = async (
  provider,
  transaction,
  { interval = POLL_INTERVAL, timeout = WAIT_TIMEOUT } = {}
) => {
  const deadline = Date.now() + timeout;
  while (Date.now() < deadline) {
    try {
      let tx = await provider.getTransactionsById([transaction.id]);
      let blockId = _get(tx, "transactions[0].containing_blocks[0]", null);
      if (blockId) {
        if (await isTransactionReverted(transaction.id, blockId)) {
          throw new Error(TX_REVERTED);
        }
        return tx;
      }
    } catch (error) {
      if (error.message === TX_REVERTED) throw error;
      // node errors are transient, keep waiting until the deadline
      console.log(error);
    }
    await awaitTimeout(interval);
  }
  throw new Error(TX_TIMEOUT);
};

/**
 * Snackbar message and variant for an error thrown by waitTransation
 */
export const describeWaitError = (error) =>
  _get(error, "message") === TX_REVERTED
    ? { message: "The contract reverted the transaction", variant: "error" }
    : { message: "Transaction not confirmed yet, check it in the explorer", variant: "warning" };
